// extracted by mini-css-extract-plugin
export default {"container":"prod_container__soPfm","title":"prod_title__rQIha","prodbox":"prod_prodbox__eHl1u","prod":"prod_prod__EQxJg","picbox":"prod_picbox__rBCcZ","name":"prod_name__PhTIP"};